<template>
   <div class="app">
      <AppHeader fixed>
         <SidebarToggler class="d-lg-none" display="md" mobile />
         <b-link class="navbar-brand" to="#">
         <img class="navbar-brand-full" src="img/brand/mysmtppro-89x27.png" width="89" height="25" alt="SMTP-PRO Logo">
         <img class="navbar-brand-minimized" src="img/brand/mysmtppro-89x27.png" width="30" height="30" alt="SMTP-PRO Logo">
         </b-link>
         <SidebarToggler class="d-md-down-none" display="lg" />
         <b-navbar-nav class="d-md-down-none ml-auto">
         <b-nav-item class="d-md-down-none">
            <DefaultHeaderDropdown/>
         </b-nav-item>
         <!--<button width="60px" v-on:click="$i18n.locale='fr'"><country-flag country="fr" size='small'/></button>-->
         <!--<button width="60px" v-on:click="$i18n.locale='en'"><country-flag country="gb" size='small'/></button>-->
         </b-navbar-nav>
         <AsideToggler class="d-none d-lg-block" />
      </AppHeader>
      <div class="app-body">
         <AppSidebar fixed>
         <SidebarHeader/>
         <SidebarForm/>
         <SidebarNav :navItems="navItems"></SidebarNav>
         <div>
            <v-chip
               small
               color="green"
            >
               {{ infos.appVersion }}
            </v-chip>
            <v-chip
               small
               v-if="!$config.isProd"
               color="green"
            >
            <small>{{ $t('titles._DEVELOPMENT') }}</small>
            </v-chip>
         </div>
         <SidebarFooter/>
         <SidebarMinimizer/>
         </AppSidebar>
         <main class="main">
         <Breadcrumb :list="list"/>
         <div class="container-fluid">
            <router-view></router-view>
         </div>
         </main>
         <AppAside fixed>
         <!--aside-->
         <DefaultAside/>
         </AppAside>
      </div>
      <TheFooter>
         <!--footer-->
         <div>
         <ddoCookies></ddoCookies>
         <a href="https://mallatius.com" target="_blank">MALLATIUS</a>
         <span class="ml-1">&copy; 2025, 2026</span>
         </div>
      </TheFooter>
   </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import CountryFlag from 'vue-country-flag'
import ddoCookies from '@/components/ddoCookies.vue';

export default {
   name: 'DefaultContainer',
   components: {
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      TheFooter,
      Breadcrumb,
      DefaultAside,
      DefaultHeaderDropdown,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      CountryFlag,
      ddoCookies,
   },

   data () {
      return {
         navItems: [],
         infos: {
            appVersion: "v1.4.2",
         }
      }
   },

   computed: {
      isProd () {
         return this.$config.isProd
      },
      name () {
         return this.$route.name
      },
      list () {
         return this.$route.matched.filter((route) => route.name || route.meta.label )
      }
   },

   async mounted() {
      await this.refresh_navItems();
   },

   methods: {

      check_single_item(item,groups,platforms) {
         var intersect = false;
         let checked_profiles = [];
         let checked_platforms = [];
         //console.log('check_single_item, name='+item.name+', groups='+JSON.stringify(groups))
         //console.log('check_single_item, name='+item.name+', platforms='+JSON.stringify(platforms))

         if ( item.attributes ) {
            if ( 'profiles' in item.attributes ) {
               checked_profiles = item.attributes.profiles.split(' ');
               for ( var j=0;j<groups.length;j++) {
                  if ( checked_profiles.includes(groups[j]) ) {
                     intersect = true;
                     break;
                  }
                  //console.log('check_single_item, intersect='+intersect+', group='+groups[j]+', profiles='+JSON.stringify(item.attributes.profiles))
               }
               item.attributes.hidden = !intersect;
               //console.log('check_single_item, So, after profiles, item.name='+item.name+', hidden='+item.attributes.hidden);
            }
            if ( !intersect ) {
               if ( 'platforms' in item.attributes ) {
                  checked_platforms = item.attributes.platforms;
                  for ( var j=0;j<platforms.length;j++) {
                     if ( checked_platforms.includes(platforms[j]) ) {
                        intersect = true;
                        break;
                     }
                     //console.log('check_single_item, intersect='+intersect+', platform='+platforms[j]+', profiles='+JSON.stringify(item.attributes.profiles))
                  }
                  item.attributes.hidden = !intersect;
                  //console.log('check_single_item, So, after platforms, item.name='+item.name+', hidden='+item.attributes.hidden);
               }
            }

            // SideBarNav builds different templates, depending on item.children :
            // <template v-if="item.children">
            //   <SidebarNavDropdown>
            // or :
            // <template v-else>
            //   <SidebarNavItem>
            // "SidebarNavItem" is the only component to react to property "hidden"
            // So, if we alternate "children" property to "alt_children", and vice-versa
            if ( item.attributes.hidden==true && item.children ) {
               item['alt_children'] = item['children'];
               delete item['children'];
            }

            if ( 'lookChildren' in item.attributes && item.children ) {
               let sub_intersect = true;
               let count_false = item.children.length;
               for ( var j=0;j< item.children.length;j++ ) {
                  sub_intersect = this.check_single_item(item.children[j],groups,platforms);
               }
            }

         }
         return intersect;
      },

      refreshNav(new_items,sessionfields,platform_list) {
         let platforms = platform_list.split(',');
         let fields = JSON.parse(sessionfields);

         let groups = [];
         //console.log('Container::refreshNav(), fields='+JSON.stringify(fields));

         if ( fields.groups ) {
            for( var i=0;i<fields.groups.length;i++) {
               groups.push(fields.groups[i]);
            }
         }

         //console.log('Container::refreshNav(), platforms='+JSON.stringify(platforms));
         //console.log('Container::refreshNav(), groups='+JSON.stringify(groups));
 
         for( var i=0;i<nav.items.length;i++) {
            if ( nav.items[i].alt_children ) {
               nav.items[i]['children'] = nav.items[i]['alt_children'];
               delete new_items[i]['alt_children'];
            }
         }
         //console.log('Container::refreshNav(), reinitialize nav.items='+JSON.stringify(nav.items));

         for( var i=0;i<nav.items.length;i++) {
            this.check_single_item(nav.items[i],groups,platforms);
         }

         //console.log('Container::refreshNav(), FINAL nav.items='+JSON.stringify(new_items));
      },

      async refresh_navItems() {
         let new_items = nav.items;
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            //console.log('refresh_navItems, api_response='+JSON.stringify(api_response))
            this.refreshNav(new_items,api_response.row.ses_sessionfields,api_response.row.platform_list);
            this.navItems = new_items;
         } else {
            this.navItems = [];
         }
      }
   }
}
</script>
